export const productList = [
    {
        id: 0,
        foodName: 'Classic Hamburger',
        productRate: 4.5,
        price: '8.99',
        discount: '10%',
        category: 'hamburger',
        description: 'Juicy beef patty with lettuce, tomato, and our secret sauce.',
        imageSrc: require('../images/foodImage/hamburger.png'),
    },
    {
        id: 1,
        foodName: 'Double Cheeseburger',
        productRate: 4.8,
        price: '10.99',
        discount: '15%',
        category: 'hamburger',
        description: 'Two beef patties, cheddar cheese, pickles, and onions.',
        imageSrc: require('../images/foodImage/hamburger2.png'),
    },
    {
        id: 2,
        foodName: 'Pepperoni Pizza',
        productRate: 4.2,
        price: '12.50',
        category: 'pizza',
        description: 'Thin crust pizza topped with pepperoni and mozzarella.',
        imageSrc: require('../images/foodImage/pizza.png'),
    },
    {
        id: 3,
        foodName: 'Margherita Pizza',
        productRate: 4.0,
        price: '11.00',
        discount: '10%',
        category: 'pizza',
        description: 'Fresh tomatoes, basil, and mozzarella on a crispy crust.',
        imageSrc: require('../images/foodImage/pizza2.png'),
    },
    {
        id: 4,
        foodName: 'Hotdog Supreme',
        productRate: 3.8,
        price: '6.50',
        category: 'hotdog',
        description: 'Grilled sausage with mustard, ketchup, and crispy onions.',
        imageSrc: require('../images/foodImage/tako.png'),
    },
    {
        id: 5,
        foodName: 'Chicken Wings',
        productRate: 4.6,
        price: '9.99',
        discount: '20%',
        category: 'chicken',
        description: 'Spicy buffalo wings served with ranch dip.',
        imageSrc: require('../images/foodImage/pasta.png'),
    },
    {
        id: 6,
        foodName: 'Grilled Salmon',
        productRate: 4.7,
        price: '14.99',
        category: 'fish',
        description: 'Fresh salmon fillet grilled to perfection with lemon butter.',
        imageSrc: require('../images/foodImage/OIP.png'),
    },
    {
        id: 7,
        foodName: 'California Roll',
        productRate: 4.3,
        price: '7.99',
        category: 'sushi',
        description: 'Crab, avocado, and cucumber rolled in seaweed and rice.',
        imageSrc: require('../images/foodImage/tako2.png'),
    },
    {
        id: 8,
        foodName: 'Spicy Tuna Roll',
        productRate: 4.1,
        price: '8.50',
        discount: '10%',
        category: 'sushi',
        description: 'Fresh tuna with spicy mayo wrapped in rice and seaweed.',
        imageSrc: require('../images/foodImage/tako2.png'),
    },
    {
        id: 9,
        foodName: 'BBQ Chicken Pizza',
        productRate: 4.4,
        price: '13.00',
        category: 'pizza',
        description: 'Tangy BBQ sauce, grilled chicken, and red onions.',
        imageSrc: require('../images/foodImage/pizza3.png'),
    },
    {
        id: 10,
        foodName: 'Fish Tacos',
        productRate: 4.0,
        price: '9.50',
        category: 'fish',
        description: 'Grilled fish with cabbage slaw and creamy sauce.',
        imageSrc: require('../images/foodImage/pizza3.png'),
    },
    {
        id: 11,
        foodName: 'Fish Tacos',
        productRate: 4.0,
        price: '9.50',
        category: 'fish',
        description: 'Grilled fish with cabbage slaw and creamy sauce.',
        imageSrc: require('../images/foodImage/pizza3.png'),
    },
    {
        id: 12,
        foodName: 'Fish Tacos',
        productRate: 4.0,
        price: '9.50',
        category: 'fish',
        description: 'Grilled fish with cabbage slaw and creamy sauce.',
        imageSrc: require('../images/foodImage/pizza3.png'),
    },
    {
        id: 13,
        foodName: 'Fish Tacos',
        productRate: 4.0,
        price: '9.50',
        category: 'fish',
        description: 'Grilled fish with cabbage slaw and creamy sauce.',
        imageSrc: require('../images/foodImage/pizza3.png'),
    },
];

